/**
* @ngdoc filter
* @name sharebase.filter:LinkRightsIcon
* @kind function
* 
* @description
*  Returns the related icon for a specific user link right
*
* @param {string|number} datetime in string or ticks.
* 
*/
export function LinkRightsIconFilter() {
	//TODO add to translation
	var ICONS = ['supervisor_account', 'mode_edit', 'remove_red_eye', 'file_upload','not_interested'];

	return function toLinkRightsIcon(val) {
		if(typeof val !== 'number'){ return '';}

		return ICONS[--val];

	};
}


// WEBPACK FOOTER //
// ./src/sharebase/filters/rightsIcon.ts